import React, { useState } from 'react';
import { Button, Row, Col } from 'antd';
import { Mail, Phone, MapPin } from 'lucide-react';
import SignupModal from './SignupModal';
import { useTranslation } from 'react-i18next';
import { track } from '../analytics';

const Footer = () => {
  const [signupOpen, setSignupOpen] = useState(false);
  const { t, i18n } = useTranslation();
  return (
    <div className="bg-dark text-white py-20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-6">{t('footer.ready')}</h2>
          <div className="space-x-4">
            <Button type="primary" size="large" className="bg-primary border-primary hover:bg-primary/80" onClick={() => setSignupOpen(true)}>
              {t('common.startFreeTrial')}
            </Button>
            <Button
              size="large"
              className="bg-white text-dark hover:bg-white/90"
              onClick={() => {
                const el = document.getElementById('book-a-call');
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                track('footer_book_demo_scroll');
              }}
            >
              {t('common.bookADemo')}
            </Button>
          </div>
        </div>

        <Row gutter={[32, 32]} justify="center" className="mb-12">
          <Col xs={24} md={8} className="text-center">
            <Mail size={24} className="text-primary mb-2 mx-auto" />
            <p>{t('footer.email')}</p>
          </Col>
          <Col xs={24} md={8} className="text-center">
            <Phone size={24} className="text-primary mb-2 mx-auto" />
            <p>{t('footer.phone')}</p>
          </Col>
          <Col xs={24} md={8} className="text-center">
            <MapPin size={24} className="text-primary mb-2 mx-auto" />
            <p>{t('footer.address')}</p>
            {i18n.language && i18n.language.startsWith('tr') && (
              <p className="mt-2">No: 280, CoZoneODTÜ TeknokentAnkara, Türkiye, 06510</p>
            )}
          </Col>
        </Row>

        <div className="text-center text-sm text-gray-400 border-t border-gray-700 pt-8">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
      <SignupModal open={signupOpen} onClose={() => setSignupOpen(false)} />
    </div>
  );
};

export default Footer;
